import { GoodsInfoSimple } from '../goods/define';
import { NumberTypeMap } from '../base/define';
import { CourseSeries } from '../courseSeries/define';

// 角色 0 超级管理员 1 运营 2 课程顾问 3辅导老师 4 课时负责人 5 直播讲师 6.外部销售 7.学科管理员 8.学科运营 9.学科课程顾问 10.学科辅导老师 11.学科直播老师
export enum ROLES {
  SUPER_ADMIN = 0, // 0 超级管理员
  OPERATOR, // 1 运营（原管理员）
  CONSULTANT, // 2 课程顾问
  TUTOR, // 3 辅导老师
  HEAD_FOR_COURSE, // 4 课时负责人
  LIVE_LECTURER, // 5 直播讲师
  OUTSIDE_SALES, // 6 外部销售
  SUBJECT_ADMIN, // 7 学科管理员
  SUBJECT_OPERATOR, // 8 学科运营
  SUBJECT_CONSULTANT, // 9 科课程顾问
  SUBJECT_TUTOR, // 10 学科辅导老师
  SUBJECT_LIVE_LECTURER, // 11 学科直播老师
}

export const SUBJECT_ROLES = [
  ROLES.SUBJECT_ADMIN,
  ROLES.SUBJECT_OPERATOR,
  ROLES.SUBJECT_CONSULTANT,
  ROLES.SUBJECT_TUTOR,
  ROLES.SUBJECT_LIVE_LECTURER,
];

export const COMMON_ROLES = [
  ROLES.SUPER_ADMIN,
  ROLES.OPERATOR,
  ROLES.CONSULTANT,
  ROLES.TUTOR,
  ROLES.HEAD_FOR_COURSE,
  ROLES.LIVE_LECTURER,
  ROLES.OUTSIDE_SALES,
];

export const ROLES_MAP: NumberTypeMap = {
  [ROLES.SUPER_ADMIN]: '超级管理员',
  [ROLES.OPERATOR]: '运营', // 管理员改为运营
  [ROLES.CONSULTANT]: '课程顾问',
  [ROLES.TUTOR]: '辅导老师',
  [ROLES.HEAD_FOR_COURSE]: '课时负责人',
  [ROLES.LIVE_LECTURER]: '直播讲师',
  [ROLES.OUTSIDE_SALES]: '外部销售',
  [ROLES.SUBJECT_ADMIN]: '学科管理员',
  [ROLES.SUBJECT_OPERATOR]: '学科运营',
  [ROLES.SUBJECT_CONSULTANT]: '科课程顾问',
  [ROLES.SUBJECT_TUTOR]: '学科辅导老师',
  [ROLES.SUBJECT_LIVE_LECTURER]: '学科直播老师',
};

export interface TeamMemberInfo {
  id?: number;
  uid?: number;
  phone: string;
  realName: string;
  nickName: string;
  wechatAccount: string;
  wechatQrCode: string;
  remark: string;
  roles: Array<ROLES>;
  isDisable?: number;
  isDeleted?: number;
  gmtCreate?: number;
  gmtModified?: number;
  goodsList?: Array<GoodsInfoSimple>;
  goodsIdList?: Array<number>;
  assignFlag?: boolean;
  assignPhone?: string;
  courseSeriesIdList?: number[]; // 更新时的入参
  courseSeriesList?: CourseSeries[]; // 列表中返回
  base?: string; // 所属基地
}

export interface TeamMemberPaginationRequest {
  pageIndex: number;
  pageSize: number;
}

export interface TeamMemberRequest {
  id: number;
  type?: number;
}

export enum TeamMemberOperateType {
  Delete = 1,
  Disable,
  CancelDisable,
}
export interface DisableTeamMemberRequest {
  id: number;
  type: TeamMemberOperateType;
}

export enum TeamSearchType {
  NICK_NAME = 1, // 花名
  PHONE, // 手机号
  BASE // 所属基地
}
